export class FoodMerchantApi {
    client;
    constructor(client) {
        this.client = client;
    }
    mid(merchantId) {
        return encodeURIComponent(merchantId);
    }
    /** Create a merchant in draft (operator). */
    createMerchant(input) {
        return this.client.request({ method: 'POST', path: '/v1/food-merchant/merchants', body: input, auth: true });
    }
    /** Set (or replace) the bank/payout account reference (operator). */
    setPayoutAccount(merchantId, payoutAccountRef) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/payout-account`, body: { payoutAccountRef }, auth: true });
    }
    /** Replace the beneficial-ownership cap table (operator). */
    setOwnership(merchantId, owners) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/ownership`, body: { owners }, auth: true });
    }
    /**
     * Submit a draft merchant for review (operator). D446 (M-12): the server files the merchant's onboarding submission in
     * the Food Ops review queue (or reuses the open one) and answers its id; activation then waits for its approval.
     */
    submit(merchantId) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/submit`, body: {}, auth: true });
    }
    /** Return an in-review merchant to draft for changes (operator). */
    resubmit(merchantId) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/resubmit`, body: {}, auth: true });
    }
    /** Activate a reviewed merchant with the already-evaluated KYB evidence (operator; evidence-gated). */
    activate(merchantId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/activate`, body: input, auth: true });
    }
    /** Reject an in-review merchant (operator; terminal). */
    reject(merchantId, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/reject`, body: { reasonCode }, auth: true });
    }
    /** Suspend an active merchant (operator). */
    suspend(merchantId, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/suspend`, body: { reasonCode }, auth: true });
    }
    /** Reactivate a suspended merchant (operator). */
    reactivate(merchantId, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/reactivate`, body: { reasonCode }, auth: true });
    }
    /** Read one merchant + its version (operator). */
    getMerchant(merchantId) {
        return this.client.request({ method: 'GET', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}`, auth: true });
    }
    /** List every merchant, newest first (operator). */
    listMerchants() {
        return this.client.request({ method: 'GET', path: '/v1/food-merchant/merchants', auth: true });
    }
    /** Create a store location under a merchant (operator). */
    createLocation(merchantId, scope) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/locations`, body: { scope }, auth: true });
    }
    /** Pause a location (operator). */
    pauseLocation(locationId) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/locations/${encodeURIComponent(locationId)}/pause`, body: {}, auth: true });
    }
    /** Resume a paused location (operator). */
    resumeLocation(locationId) {
        return this.client.request({ method: 'POST', path: `/v1/food-merchant/locations/${encodeURIComponent(locationId)}/resume`, body: {}, auth: true });
    }
    /** D446: the store's menu link and courier pickup point. */
    storeSetup(locationId) {
        return this.client.request({ method: 'GET', path: `/v1/food-merchant/locations/${encodeURIComponent(locationId)}/setup`, auth: true });
    }
    /** D446 (M-12): link the menu the store sells — a menu the merchant published (`MENU_NOT_FOUND` / `MENU_NOT_MERCHANTS`). */
    setStoreMenu(locationId, menuId) {
        return this.client.request({ method: 'PUT', path: `/v1/food-merchant/locations/${encodeURIComponent(locationId)}/menu`, body: { menuId }, auth: true });
    }
    /** D446 (M-02): place (or move) where couriers collect the store's orders, in the store's market (`PICKUP_POINT_INVALID`). */
    setStorePickupPoint(locationId, point) {
        return this.client.request({ method: 'PUT', path: `/v1/food-merchant/locations/${encodeURIComponent(locationId)}/pickup-point`, body: point, auth: true });
    }
    /** List a merchant's locations, newest first (operator). */
    listLocations(merchantId) {
        return this.client.request({ method: 'GET', path: `/v1/food-merchant/merchants/${this.mid(merchantId)}/locations`, auth: true });
    }
}
//# sourceMappingURL=food-merchant.js.map